export default {"src":"/_next/static/media/calendar-icon-edu.129bb190.svg","height":18,"width":18};